import React from "react";
import { Clapperboard, Drama, Headset, SlidersHorizontal } from "lucide-react";

const ITEMS = [
  { icon: Clapperboard, title: "Show Notes", text: "Stage managers draft Rehearsal and Show Notes; you edit, approve and publish them to each production." },
  { icon: Drama, title: "Thespian Points", text: "Members claim International Thespian Society points and track their ITS rank." },
  { icon: Headset, title: "Stage Manager group", text: "We created it for you. Its members can draft notes and appear on each report's Manager line." },
  { icon: SlidersHorizontal, title: "Program switches", text: "Turn Lettering Points or the Merit System off if your program doesn't use them." },
];

// Step 1: what the Theatre plan adds.
export default function WelcomeStep() {
  return (
    <div className="grid gap-3 sm:grid-cols-2" data-testid="theatre-setup-welcome">
      {ITEMS.map((it, i) => (
        <div key={it.title} style={{ animationDelay: `${i * 60}ms` }} className="rounded-xl border border-slate-200 bg-white p-4 animate-fade-in-up">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-rose-50 text-rose-600"><it.icon className="h-4 w-4" /></span>
          <p className="mt-3 font-semibold text-slate-900">{it.title}</p>
          <p className="mt-1 text-sm text-slate-500">{it.text}</p>
        </div>
      ))}
    </div>
  );
}
